export const HTTP_CLIENT_ERRORS = {
  400: 'Bad Request', // The server cannot process the request due to a client error
  401: 'Unauthorized', // Authentication is required and has failed or not been provided
  402: 'Payment Required', // Reserved for future use (e.g., digital payments)
  403: 'Forbidden', // The client does not have access rights to the content
  404: 'Not Found', // The requested resource could not be found
  405: 'Method Not Allowed', // The request method is not supported by the resource
  406: 'Not Acceptable', // The requested resource is not available in a format that the client accepts
  407: 'Proxy Authentication Required', // The client must authenticate with a proxy before making a request
  408: 'Request Timeout', // The server timed out waiting for the client request
  409: 'Conflict', // The request conflicts with the current state of the server
  410: 'Gone', // The resource is no longer available and will not be available again
  411: 'Length Required', // The server requires a Content-Length header
  412: 'Precondition Failed', // A precondition specified in the request headers was not met
  413: 'Payload Too Large', // The request payload exceeds the server's limit
  414: 'URI Too Long', // The requested URL is too long for the server to process
  415: 'Unsupported Media Type', // The media format is not supported by the server
  416: 'Range Not Satisfiable', // The requested range is not valid for the target resource
  417: 'Expectation Failed', // The server cannot meet the expectations specified in the request headers
  421: 'Misdirected Request', // The request was directed at a server that cannot respond
  422: 'Unprocessable Entity', // The request is well-formed but cannot be processed due to validation errors
}


export const HTTP_SERVER_ERRORS = {
  500: 'Internal Server Error', // Generic server error when an unexpected condition occurs
  501: 'Not Implemented', // The server does not support the requested functionality
  502: 'Bad Gateway', // The server received an invalid response from the upstream server
  503: 'Service Unavailable', // The server is currently unable to handle the request
  504: 'Gateway Timeout', // The server did not receive a timely response from an upstream server
  505: 'HTTP Version Not Supported', // The server does not support the HTTP version used in the request
  506: 'Variant Also Negotiates', // Internal server configuration error (RFC 2295)
  507: 'Insufficient Storage', // The server is unable to store the representation needed to complete the request (WebDAV)
  508: 'Loop Detected', // The server detected an infinite loop while processing a request (WebDAV)
  509: 'Bandwidth Limit Exceeded', // The server has exceeded the bandwidth limit (Non-standard)
  510: 'Not Extended', // Further extensions to the request are required (RFC 2774)
  511: 'Network Authentication Required', // The client needs to authenticate to access the network (RFC 6585)
}

/**
 * Function to get the standard HTTP message based on server error status code
 * @param {number} statusCode - The HTTP status code
 * @returns {string} The corresponding standard message
 */
export const getHttpServerErrorMessage = (statusCode) => {
  return HTTP_SERVER_ERRORS[statusCode] || 'Unknown Server Error'
}

/**
 * Function to get the standard HTTP message based on status code
 * @param {number} statusCode - The HTTP status code
 * @returns {string} The corresponding standard message
 */
export const getHttpClientErrorMessage = (statusCode) => {
  return HTTP_CLIENT_ERRORS[statusCode] || 'Unknown Client Error'
}
